import { usePromoteFormData } from '../../../formContext/formData';

export function useIsMembershipEligible(): boolean {
	const {
		membershipProgram,
		user: { hasSubscription },
		featureConfigs: { membershipPPMUEnabled },
	} = usePromoteFormData();

	if (!membershipPPMUEnabled || !membershipProgram || hasSubscription) return false;

	return true;
}
